import { FC } from "react";
import { providerConnectionDetails } from "@/components/pages/integrations/components/provider-connections/common/utils/constants/ProviderConnectionDetails";
import { IntegrationsEmptyState } from "@/components/pages/integrations/components/common/components/IntegrationsEmptyState";
import { snowflakeConnectionGridColumns } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/snowflakeConnectionGridColumns";
import { useGetUsersMeProviderConnectionsSnowflakeQuery } from "@/services/cloudchipr.api";
import { SnowflakeConnectionConnectButton } from "@/components/pages/integrations/components/provider-connections/snowflake/components/SnowflakeConnectionConnectButton";
import { IntegrationsDataGrid } from "@/components/pages/integrations/components/common/components/IntegrationsDataGrid";

export const SnowflakeConnectionGrid: FC = () => {
  const { data, isLoading } = useGetUsersMeProviderConnectionsSnowflakeQuery();

  if (!isLoading && !data?.length) {
    return <EmptyState />;
  }

  return (
    <IntegrationsDataGrid
      columnDefs={snowflakeConnectionGridColumns}
      data={data}
      loading={isLoading}
      uniqueKey="snowflakeConnectionDataGrid"
      actionButton={<SnowflakeConnectionConnectButton withStartIcon />}
    />
  );
};

const details = providerConnectionDetails["snowflake"];

const EmptyState: FC = () => (
  <IntegrationsEmptyState
    title={details.noDataDescription}
    description={details.description}
  >
    <SnowflakeConnectionConnectButton withStartIcon variant="contained" />
  </IntegrationsEmptyState>
);
